<template>
  <div style="background-color: #2D2E2C;" class="menu" :class="{ 'small-menu': smallMenu }">
  
    <MenuItem
      v-for="(item, index) in menuTree"
      :key="index"
      :data="item.children"
      :label="item.label"
      :icon="item.icon"
      :url="item.url"
      :depth="0"
      :smallMenu="smallMenu"
    />

    <!--<button type="button" class="boton-menu"  @click="smallMenu = !smallMenu">
       <svg class="fill-orange-700 w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>      
      </button>-->
  </div>
</template>

<script>
import MenuItem from '@/Shared/MenuItem';

export default {
  name: 'recursive-menu',
  data: () => ({
    smallMenu: false,
    menuTree: [
    {
        label: "Panel",
        icon: "store-front",
        url:"/",
      },
      {
            label: "Clientes",
            icon: "clients",
            children: [
          {
            label: "Generales",
            url: "/contacts"
          },          
        ]
          },
          {
            label: "Comercios",
            icon: "shopping-cart",
            children: [
          {
            label: "Generales",
            url: "/organizations"
          },          
        ]
          },
          {
        label: "Transacciones",
        icon: "book",
        children: [
          {
            label: "Generales",
            url: "/transacciones"
          },
        ]
      },
    ]
  }),
  components: {
    MenuItem
  }
}
</script>

<style lang="scss" scoped>
.menu {
  background-color: #000;
  position: relative;
  width: 225px;
  left: 0;
  border-right: 1px solid #2D2E2C;
  transition: all .3s ease;
  overflow: auto;
  .boton-menu {
    position: fixed;
    left: 250px;
    font-size: 20px;
    top: 25px;
    user-select: none;
    cursor: pointer;
    transition: all .3s ease;
  }
  &.small-menu {
    overflow: inherit;
    width: 70px;
    padding-top: 20px;
    i {
      left: 20px;
    }
  }
}
</style>